import React from 'react'
import { Segment } from 'semantic-ui-react'

import CTA from './CTA'

const SpeedGraph = ({}) => {
  return (
    <Segment raised secondary>
      <p>
        The media and the government are inefficient in disseminating critical
        recall information to consumers. Often times it takes{' '}
        <strong>days</strong> or <strong>weeks</strong> before a major recall is
        announced by the media.
      </p>
      <p>
        Consumers are asked to be proactive, but they are at the mercy of slow
        channels to receive important news. Some recalls aren't event mentioned
        anywhere except official channels.
      </p>
      {/* <p>Graph here</p> */}
      <p>
        Recall Monitor notifies you of product recalls{' '}
        <strong>faster than any other channel</strong> - instantly.
      </p>
      <CTA />
    </Segment>
  )
}

export default SpeedGraph
